const validator = {
  required(msg, trigger) {
    return {
      required: true,
      message: msg,
      trigger: trigger ? trigger : "blur"
    };
  },
  /**手机号码验证 */
  checkPhone(rule, value, callback) {
    if (!/^1[3456789]\d{9}$/.test(value)) {
      callback(new Error("手机号码格式错误"));
    }
    callback();
  },
  /**邮箱验证 */
  checkMail(rule, value, callback) {
    if (!/^[A-Za-z0-9._-\u4e00-\u9fa5]+@[a-zA-Z0-9]+(\.([a-zA-Z]{2,}))+$/.test(value)) {
      callback(new Error("邮箱格式错误"));
    }
    callback();
  },
  /**经费最大值设置 */
  checkFuns(rule, value, callback) {
    /**最大值为10位 */
    let max = 9999999999.99;
    if (!/(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/g.test(value)) {
      callback(new Error("输入金额格式不正确，例如2000.01"));
    } else if (value > max) {
      callback(new Error("输入金额不得大于壹佰亿圆整"));
    }
    callback();
  },
  /**经费最大值设置 */
  nums(rule, value, callback) {
    /**最大值为10位 */
    let max = 9999999999.99;
    if (!/(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/g.test(value)) {
      callback(new Error("输入金额格式不正确,只能是整数"));
    } else if (value > max) {
      callback(new Error("输入金额不得大于壹佰亿圆整"));
    }
    callback();
  },
  /**验证大项 */
  checkDisciplineList(rule, value, callback) {
    if (value.length == 0) {
      callback(new Error("大项不能为空"));
    }
    callback();
  },
  /**验证期次 */
  times: (rule, value, callback) => {
    let validReg = /^[0-9]+$/;
    if (value != undefined && value != "" && !validReg.test(value)) {
      callback(new Error("请输入数字"));
    } else if (value != undefined && value != "" && (value < 0 || value > 999)) {
      callback(new Error("请输入合理的期次数字"));
    }
    callback();
  },
  /**登录密码 长度为6 - 20位，可输入数字字母_@#*!+- */
  checkPwd: (rule, value, callback) => {
    let validReg = /^(?![a-zA-z]+$)(?!\d+$)(?![!_@~#*!+-]+$)(?![a-zA-z!_@~#*!+-]+$)(?![\d!_@~#*!+-]+$)[a-zA-Z\d!_@~#*!+-]{6,16}$/;
    if (value != "" && !validReg.test(value)) {
      callback(new Error("请输入格式正确的密码，至少包含一位数字、字母，长度为6 - 16位！"));
    }
    callback();
  },
  /**足球类型限制 */
  footballType: (rule, value, callback) => {
    if (value === "TRAINING_CENTER") {
      callback(new Error("因为政策关系，您选择的类型无法新增。"));
    }
    callback();
  }
};
export default validator;
